import React from "react";
import { FiArrowRight } from "react-icons/fi";
import Button from "../common/Button";
import ProductCard from "../product/ProductCard";

const ProductRail = ({ title, eyebrow, description, products, dark = false, href = "/shop" }) => (
  <section className={`section product-rail-section ${dark ? "product-rail-section--dark" : ""}`}>
    <div className="site-container">
      <header className="section-heading section-heading--split">
        <div>
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <Button to={href} variant={dark ? "light-outline" : "text"}>
          View all <FiArrowRight aria-hidden="true" />
        </Button>
      </header>
      <div className="product-rail" role="list" aria-label={title}>
        {products.map((product) => (
          <div className="product-rail__item" role="listitem" key={product.id}>
            <ProductCard product={product} showDescription={false} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProductRail;
